/* Mobile reflow: move review badge + title + subheadline above the gallery on small
   screens (competitor pattern), and move them back on desktop. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var moved = [];
  var slot = null;

  var findPieces = function () {
    var info = document.querySelector('.product__info-container');
    if (!info) return [];
    var pieces = [];
    var badge = info.querySelector('.pawable-review-badge');
    var title = info.querySelector('.product__title');
    var subhead = info.querySelector('.product__text');
    if (badge) pieces.push(badge);
    if (title) pieces.push(title);
    if (subhead) pieces.push(subhead);
    return pieces;
  };

  var ensureSlot = function () {
    if (slot) return slot;
    var media = document.querySelector('.product__media-wrapper');
    if (!media || !media.parentNode) return null;
    slot = document.createElement('div');
    slot.className = 'pawable-mobile-head';
    media.parentNode.insertBefore(slot, media);
    return slot;
  };

  var apply = function () {
    if (mq.matches) {
      var target = ensureSlot();
      if (!target) return;
      findPieces().forEach(function (el) {
        if (el.parentNode !== target) {
          moved.push({ el: el, parent: el.parentNode, next: el.nextSibling });
          target.appendChild(el);
        }
      });
    } else if (moved.length) {
      moved.forEach(function (m) {
        m.parent.insertBefore(m.el, m.next);
      });
      moved = [];
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
})();
